import { FC, useMemo } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

const StarIcon: FC<{ size: number; color: string }> = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
  </svg>
);

/**
 * Collect Button (v2) — admin-preview-only. "Floating" is shown inline here
 * (not position:fixed) since this preview renders inside our own admin card
 * — the real embed (widget-v2.js, renderCollect) fixes it to the viewport.
 */
const WidgetTemplate24: FC<IWidgetTemplate> = ({ company, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("collect", style);
  const payload = useMemo(() => ({ companyId, widgetId: 24 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-collect`,
    [companyId],
  );
  const linkProps = { href: profileUrl, target: "_blank" as const, rel: "noopener", onClick: () => ReachClick(payload) };

  if (resolvedStyle === "floating") {
    return (
      <div className="d-flex justify-content-center">
        <a
          {...linkProps}
          className="d-inline-flex align-items-center justify-content-center"
          style={{ width: 44, height: 44, borderRadius: 999, background: "#006bf1", color: "#fff", boxShadow: "0 4px 12px rgba(0,107,241,0.35)", textDecoration: "none" }}
        >
          <StarIcon size={17} color="#fff" />
        </a>
      </div>
    );
  }

  const outline = resolvedStyle === "outline";
  return (
    <div className="d-flex justify-content-center">
      <a
        {...linkProps}
        className="d-inline-flex align-items-center gap-2"
        style={{
          border: outline ? "2px solid #006bf1" : "none",
          background: outline ? "transparent" : "#006bf1",
          color: outline ? "#006bf1" : "#fff",
          borderRadius: 8,
          padding: "8px 14px",
          fontSize: 12.5,
          fontWeight: 600,
          textDecoration: "none",
        }}
      >
        <StarIcon size={13} color={outline ? "#006bf1" : "#fff"} />
        Review us on TrustFinance
      </a>
    </div>
  );
};

export default WidgetTemplate24;
